import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePutRequest } from 'utils/api'
import urls from 'utils/urls'
import { UTILISATION } from 'utils/constants'

export default function EditOperationForm({
  setOperations,
  params,
  operations,
  setSelected,
  moterType,
  vehiculesTypes,
  typeDeBien,
  allvehicules,
  allimmobiliers,
}) {
  const [open, setOpen] = useState(false)
  const [carac, setCarac] = useState('')
  const [subType, setSubType] = useState('')
  const [typeObject, setTypeObject] = useState(0)
  const [immobiliers, setImmobiliers] = useState([])
  const [vehicules, setVehicules] = useState([])

  const typeObj = [
    { label: 'Véhicules', id: 1 },
    { label: 'Immobilier', id: 2 },
    { label: 'Autres', id: 3 },
  ]

  const log = async () => {
    if (params[0].EquipementType === 'Véhicules') {
      setTypeObject(1)
      setValue('EquipementType', { label: params[0].EquipementType, id: 1 })
      const esubtype = vehiculesTypes.filter((v) => v.label === params[0].EquipementSubType)
      setValue('EquipementSubType', esubtype[0])
      const ecarac = moterType.filter((v) => v.label === params[0].EquipementCarac)
      setValue('EquipementCarac', ecarac[0])
      await fetchVehicules(esubtype[0]?.id, ecarac[0]?.id, true)
    } else if (params[0].EquipementType === 'Immobilier') {
      setTypeObject(2)
      setValue('EquipementType', { label: params[0].EquipementType, id: 2 })
      const esubtype = typeDeBien.filter((v) => v.label === params[0].EquipementSubType)
      setValue('EquipementSubType', esubtype[0])
      const ecarac = UTILISATION.filter((v) => v.label === params[0].EquipementCarac)
      setValue('EquipementCarac', ecarac[0])
      await fetchImmobiliers(esubtype[0].id, ecarac[0].label, true)
    } else {
      setTypeObject(3)
      setValue('EquipementType', { label: params[0].EquipementType, id: 3 })
      setValue('EquipementSubType', params[0].EquipementSubType)
      setValue('EquipementCarac', params[0].EquipementCarac)
      setValue('EquipementName', params[0].EquipementName)
    }

    setOpen(true)
  }
  useEffect(() => {
    setTypeObject(0)
    log()
  }, [])

  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      id: params[0].id,
      EquipementType: '',
      EquipementSubType: '',
      EquipementCarac: '',
      EquipementName: '',
    },
  })

  const handleClose = () => {
    setSelected(false)
    setOpen(false)
    reset()
    setTypeObject(0)
    setSubType('')
    setCarac('')
  }

  const onSubmit = async (data) => {
    let payload = {}
    if (data.EquipementType.id === 1 || data.EquipementType.id === 2) {
      payload = {
        ...data,
        EquipementType: data.EquipementType.label,
        EquipementSubType: data.EquipementSubType.label,
        EquipementCarac: data.EquipementCarac.label,
        EquipementName: data.EquipementName.label,
        ObjectId: data.EquipementName.id,
      }
    } else {
      payload = {
        ...data,
        EquipementType: data.EquipementType.label,
      }
    }

    const response = await makePutRequest(
      urls.crudEntretienOperations + `${data.id}/`,
      payload,
      {},
      true,
    )
    if (response.status === 200) {
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))
      handleClose()
    }
  }

  const fetchImmobiliers = async (v1, v2, v3 = false) => {
    let elements = document.getElementsByName('EquipementName')
    elements.forEach((v) => {
      v = v.getElementsByClassName('MuiAutocomplete-clearIndicator')
      if (v.length > 0) v[0].click()
    })
    setValue('EquipementName', '')
    setImmobiliers([])
    const url = urls.fetchAllImmobiliers + `?utilisation=${v2}&type_de_bien=${v1}`
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterImmobiliers = []
      data.forEach((v) => {
        filterImmobiliers.push({ id: v.id, label: `${v.nom}` })
      })
      setImmobiliers([...filterImmobiliers])
      if (v3) {
        let veh = immobiliers.filter((v) => v.label === params[0].EquipementName)
        setValue('EquipementName', veh[0])
      }
    }
  }
  const fetchVehicules = async (v1, v2, v3 = false) => {
    let elements = document.getElementsByName('EquipementName')
    elements.forEach((v) => {
      v = v.getElementsByClassName('MuiAutocomplete-clearIndicator')
      if (v.length > 0) v[0].click()
    })
    setValue('EquipementName', '')
    setVehicules([])
    const url = urls.fetchVehicles + `?vehicleType=${v1}&Motortype=${v2}`
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterVehicules = []
      data.forEach((v) => {
        filterVehicules.push({ id: v.id, label: `${v.Name}` })
      })
      setVehicules([...filterVehicules])
      if (v3) {
        let veh = vehicules.filter((v) => v.label === params[0].EquipementName)
        setValue('EquipementName', veh[0])
      }
    }
  }

  const clearData = () => {
    reset()
    setCarac('')
    setSubType('')
  }
  return (
    <>
      {open && (
        <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
          <DialogTitle sx={{ backgroundColor: '#202020' }}>Modifier</DialogTitle>
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogContent>
              <ComboBox
                handleAutoComplete={(e, j) => {
                  if (j.id === 1) {
                    clearData()
                    setTypeObject(1)
                  } else if (j.id === 2) {
                    clearData()
                    setTypeObject(2)
                  } else if (j.id === 3) {
                    clearData()
                    setTypeObject(3)
                  }
                  setValue('EquipementType', j)
                }}
                label="Equipement Type"
                data={typeObj}
                name="EquipementType"
                required={true}
                control={control}
                selectedValue={getValues('EquipementType')}
              />
              {typeObject === 1 ? (
                <>
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('EquipementSubType', j)
                      setSubType(j.id)
                      fetchVehicules(j.id, carac)
                    }}
                    label="Equipement Sub Type"
                    data={vehiculesTypes}
                    name="EquipementSubType"
                    required={true}
                    control={control}
                    selectedValue={getValues('EquipementSubType')}
                  />
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('EquipementCarac', j)
                      setCarac(j.id)
                      fetchVehicules(subType, j.id)
                    }}
                    label="Equipement Carac"
                    data={moterType}
                    name="EquipementCarac"
                    required={true}
                    control={control}
                    selectedValue={getValues('EquipementCarac')}
                  />
                  <ComboBox
                    handleAutoComplete={(e, j) => setValue('EquipementName', j)}
                    label="Equipement Name"
                    data={vehicules}
                    name="EquipementName"
                    required={true}
                    // selectedValue={getValues('EquipementName')}
                  />
                </>
              ) : (
                ''
              )}
              {typeObject === 2 ? (
                <>
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('EquipementSubType', j)
                      setSubType(j.id)
                      fetchImmobiliers(j.id, carac)
                    }}
                    label="Equipement Sub Type"
                    data={typeDeBien}
                    name="EquipementSubType"
                    required={true}
                    control={control}
                    selectedValue={getValues('EquipementSubType')}
                  />
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('EquipementCarac', j)
                      setCarac(j.label)
                      fetchImmobiliers(subType, j.label)
                    }}
                    label="Equipement Carac"
                    data={UTILISATION}
                    name="EquipementCarac"
                    required={true}
                    control={control}
                    selectedValue={getValues('EquipementCarac')}
                  />
                  <ComboBox
                    handleAutoComplete={(e, j) => setValue('EquipementName', j)}
                    label="Equipement Name"
                    data={immobiliers}
                    name="EquipementName"
                    required={true}
                    // selectedValue={getValues('EquipementName')}
                  />
                </>
              ) : (
                ''
              )}

              {typeObject === 3 ? (
                <>
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'text',
                      required: true,
                      size: 'small',
                    }}
                    rules={{ required: true }}
                    name="EquipementSubType"
                    label="Equipement Sub Type"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'text',
                      required: true,
                      size: 'small',
                    }}
                    rules={{ required: true }}
                    name="EquipementCarac"
                    label="Equipement Carac"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'text',
                      required: true,
                      size: 'small',
                    }}
                    rules={{ required: true }}
                    name="EquipementName"
                    label="Equipement Name"
                  />
                </>
              ) : (
                ''
              )}
            </DialogContent>
            <DialogActions>
              <Button type="submit">Valider</Button>
              <Button onClick={handleClose}>Annuler</Button>
            </DialogActions>
          </form>
        </Dialog>
      )}
    </>
  )
}
